import {has_ssr} from "@core/helpers/render-type";
import {detect_device_server, is_mobile_device_server} from "@core/helpers/server/device";

// The browser side (ua-parser-js, ~17KB) is loaded on first use instead of with every page: these helpers are async
// anyway, and the first client GraphQL call is the earliest one that needs it (all sites).
const client_device = () => import("@core/helpers/client/device");

export const is_mobile_device = async () => {
    if (has_ssr()) {
        return await is_mobile_device_server()
    } else {
        return (await client_device()).is_mobile_device_client()
    }
}

export const detect_device = async () => {
    if (has_ssr()) {
        return await detect_device_server()
    } else {
        return (await client_device()).detect_device_client()
    }
}
